module.exports = __webpack_public_path__ + "static/media/linkCard_incentives.0ed09dbd.svg";